export default {
  "Header.Title": "パーソナルデータダッシュボード(法人のお客さま向け)",
  "Header.NotLogin": "ログインしていません",
  "Header.DAccountStart": "ビジネスdアカウントの",
  "Header.DAccountLink": "新規登録はこちら",
  "Header.DAccountEnd": " ",
}
